/**
 * How a task's priority presents itself.
 *
 * Out of `components/ui/status-colors.ts:15-34`, the first two of that file's seven ways. It is not
 * `entries/presentation.ts`'s: that record answers "what does this *kind* look like", one row per
 * `EntryType`, while these are a task's own metadata values.
 *
 * `priority` is legacy data — `TaskMeta.important` is what the UI writes now — but three surfaces
 * still render it, so the vocabulary moves with the slice rather than being deleted.
 */

import type { TaskPriority } from './meta'

/** Priority badge colour classes. */
export const PRIORITY_COLORS: Record<TaskPriority | 'urgent', string> = {
  urgent: 'bg-destructive/10 text-destructive border-destructive/20',
  high: 'bg-orange-500/10 text-orange-600 border-orange-500/20 dark:text-orange-400 dark:border-orange-400/20',
  medium: 'bg-primary/10 text-primary border-primary/20',
  low: 'bg-muted text-muted-foreground border-border',
}

/** Priority labels for display. */
export const PRIORITY_LABELS: Record<TaskPriority | 'urgent', string> = {
  urgent: 'Urgent',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
}
